import { defaultIconColor } from '../constants';
import { useIntl } from 'react-intl';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

type PropsType = SVGComponentPropsType & {
  tooltipMessageId?: string;
};

export default ({ color = defaultIconColor, size = defaultSize, tooltipMessageId = '', ...props }: PropsType) => {
  const intl = useIntl();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${defaultSize} ${defaultSize}`}
      {...props}
    >
      {tooltipMessageId && <title>{intl.formatMessage({ id: tooltipMessageId })}</title>}
      <path
        d="M16.302 4l.19.006a3 3 0 0 1 2.5 1.668l.084.184.942 2.288L21.28 7.2a1 1 0 0 1 .6-.2H23v2h-1l-1.21 1.021L22 13v7h-2.5L18 18H6l-1.31 2H2v-7l1.21-2.979L2 9H1V7h1.158a1 1 0 0 1 .612.209l1.212.937.942-2.288.083-.184a3 3 0 0 1 2.3-1.649l.2-.019L7.698 4h8.604zm-.131 2H7.829l-.128.008a1 1 0 0 0-.719.46l-.061.113L4 13v4.5L5 16h14l1 1.5V13l-2.921-6.42a1 1 0 0 0-.78-.572L16.171 6zm1.329 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};
